
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProcessInspectionGrid extends Serenity.EntityGrid<ProcessInspectionRow, any> {
        protected getColumnsKey() { return 'OMS.ProcessInspection'; }
        protected getDialogType() { return ProcessInspectionDialog; }
        protected getIdProperty() { return ProcessInspectionRow.idProperty; }
        protected getInsertPermission() { return ProcessInspectionRow.insertPermission; }
        protected getLocalTextPrefix() { return ProcessInspectionRow.localTextPrefix; }
        protected getService() { return ProcessInspectionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}